export default "__VITE_ASSET__DaV2qkKG__"